import { getPageAllowedRoles } from "./roles";

function getNavigationItemDisplayTextValue(page) {
  switch (page.Id) {
    case "admin_settings":
    case "blacklist_and_mail_exclusion":
    case "global_settings":
    case "g4c_communicationoptions":
    case "journal_daily_report":
    case "page":
    case "report":
    case "search":
    case "sitemap":
      return page.RecordName;
    default:
      return page.ListName;
  }
}

function getNavigationItemToAlwaysDisplayDetails(page) {
  switch (page) {
    case "/admin-settings":
      return {
        to: "/admin-settings",
        text: "Admin Settings",
        recordName: "Admin Settings",
        allowedRoles: getPageAllowedRoles("admin-settings"),
      };
    case "/global-settings":
      return {
        to: "/global-settings",
        text: "Global Settings",
        recordName: "Global Settings",
        allowedRoles: getPageAllowedRoles("global-settings"),
      };
    case "/search":
      return {
        to: "/search",
        text: "Search",
        recordName: "Search",
        allowedRoles: getPageAllowedRoles("search"),
      };
    case "/sitemap":
      return {
        to: "/sitemap",
        text: "Sitemap",
        recordName: "Sitemap",
        allowedRoles: getPageAllowedRoles("sitemap"),
      };
    default:
      return {};
  }
}

function getNavigationItemDetails(page) {
  switch (page.Id) {
    case "account":
      return {
        identifiers: ["/accounts", "/account"],
        to: "/accounts",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("account"),
      };
    case "admin_settings":
      return {
        to: "/admin-settings",
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("admin-settings"),
      };
    case "blacklist_and_mail_exclusion":
      return {
        to: "/blacklist",
        description:
          "Enable only if the client is trusted to responsibly manage blacklisted email addresses",
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("blacklist"),
      };
    case "campaign":
      return {
        identifiers: ["/campaigns", "/campaign"],
        to: "/campaigns",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("campaign"),
      };
    case "contact":
      return {
        identifiers: [
          "/contacts",
          "/contact",
          "/contact-audit",
          "/on-hold-audit",
        ],
        to: "/contacts",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("contact"),
      };
    case "global_settings":
      return {
        to: "/global-settings",
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("global-settings"),
      };
    case "g4_city":
      return {
        identifiers: ["/cities", "/city"],
        to: "/cities",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("city"),
      };
    case "g4_country":
      return {
        identifiers: ["/countries", "/country"],
        to: "/countries",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("country"),
      };
    case "g4_group":
      return {
        identifiers: ["/groups", "/group"],
        to: "/groups",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("group"),
      };
    case "g4_question":
      return {
        identifiers: ["/questions", "/question"],
        to: "/questions",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("question"),
      };
    case "g4_region":
      return {
        identifiers: ["/regions", "/region"],
        to: "/regions",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("region"),
      };
    case "g4a_accesscontrol":
      return {
        identifiers: ["/access-control", "/access-controls"],
        to: "/access-controls",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("access-control"),
      };
    case "g4b_accesscontrolprovider":
      return {
        identifiers: [
          "/access-control-providers",
          "/access-control-provider",
        ],
        to: "/access-control-providers",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("access-control-provider"),
      };
    case "g4b_accesspoint":
      return {
        identifiers: ["/access-points", "/access-point"],
        to: "/access-points",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("access-point"),
      };
    case "g4b_additionalproduct":
      return {
        identifiers: ["/additional-products", "/additional-product"],
        to: "/additional-products",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("additional-product"),
      };
    case "g4b_analysiscategory":
      return {
        identifiers: ["/product-categories", "/product-category"],
        to: "/product-categories",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("product-category"),
      };
    case "g4b_block":
      return {
        identifiers: ["/blocks", "/block"],
        to: "/blocks",
        description:
          "This will only display if 'Enable Fixtures and Series' field is checked on the Admin Settings page",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("block"),
      };
    case "g4b_bookableresource":
      return {
        identifiers: ["/bookable-resources", "/bookable-resource"],
        to: "/bookable-resources",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("bookable-resource"),
      };
    case "g4b_booking":
      return {
        identifiers: ["/bookings", "/booking"],
        to: "/bookings",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("booking"),
      };
    case "g4b_bookingoperator":
      return {
        identifiers: ["/operators", "/operator"],
        to: "/operators",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("operator"),
      };
    case "g4b_channel":
      return {
        identifiers: ["/channels", "/channel"],
        to: "/channels",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("channel"),
      };
    case "g4b_channelpricelist":
      return {
        identifiers: ["/channel-price-lists", "/channel-price-list"],
        to: "/channel-price-lists",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("channel-price-list"),
      };
    case "g4b_commissioncategory":
      return {
        identifiers: [
          "/commission-categories",
          "/commission-category",
        ],
        to: "/commission-categories",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("commission-category"),
      };
    case "g4b_commissiongroup":
      return {
        identifiers: ["/commission-groups", "/commission-group"],
        to: "/commission-groups",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("commission-group"),
      };
    case "g4b_commissionrate":
      return {
        identifiers: ["/commission-rates", "/commission-rate"],
        to: "/commission-rates",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("commission-rate"),
      };
    case "g4b_coupon":
      return {
        identifiers: ["/coupons", "/coupon"],
        to: "/coupons",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("coupon"),
      };
    case "g4b_coupontype":
      return {
        identifiers: ["/coupon-types", "/coupon-type"],
        to: "/coupon-types",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("coupon-type"),
      };
    case "g4b_fixture":
      return {
        identifiers: ["/fixtures", "/fixture"],
        to: "/fixtures",
        description:
          "This will only display if 'Enable Fixtures and Series' field is checked on the Admin Settings page",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("fixture"),
      };
    case "g4b_invoicebatchheader":
      return {
        identifiers: [
          "/invoice-batch-headers",
          "/invoice-batch-header",
          "/invoice",
        ],
        to: "/invoice-batch-headers",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("invoice-batch-header"),
      };
    case "g4b_onholdreason":
      return {
        identifiers: ["/on-hold-reasons", "/on-hold-reason"],
        to: "/on-hold-reasons",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("on-hold-reason"),
      };
    case "g4b_operatorgroup":
      return {
        identifiers: ["/operator-groups", "/operator-group"],
        to: "/operator-groups",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("operator-group"),
      };
    case "g4b_paymentbatch":
      return {
        identifiers: ["/payment-batches", "/payment-batch"],
        to: "/payment-batches",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("payment-batch"),
      };
    case "g4b_paymentmethod":
      return {
        identifiers: ["/payment-methods", "/payment-method"],
        to: "/payment-methods",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("payment-method"),
      };
    case "g4b_pricebreakgroup":
      return {
        identifiers: [
          "/price-break-groups",
          "/price-break-group",
          "/price-break",
        ],
        to: "/price-break-groups",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("price-break-group"),
      };
    case "g4b_printer":
      return {
        identifiers: ["/printers", "/printer"],
        to: "/printers",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("printer"),
      };
    case "g4b_printtransform":
      return {
        identifiers: ["/print-transforms", "/print-transform"],
        to: "/print-transforms",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("print-transform"),
      };
    case "g4b_productbase":
      return {
        identifiers: ["/products", "/product"],
        to: "/products",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("product"),
      };
    case "g4b_productcalendar":
      return {
        identifiers: ["/product-calendars", "/product-calendar"],
        to: "/product-calendars",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("product-calendar"),
      };
    case "g4b_productgroup":
      return {
        identifiers: ["/product-groups", "/product-group"],
        to: "/product-groups",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("product-group"),
      };
    case "g4b_promotion":
      return {
        identifiers: ["/promotions", "/promotion"],
        to: "/promotions",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("promotion"),
      };
    case "g4b_promotionexclusiondate":
      return {
        identifiers: [
          "/promotion-exclusion-dates",
          "/promotion-exclusion-date",
        ],
        to: "/promotion-exclusion-dates",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("promotion-exclusion-date"),
      };
    case "g4b_promotiontype":
      return {
        identifiers: ["/promotion-types", "/promotion-type"],
        to: "/promotion-types",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("promotion-type"),
      };
    case "g4b_reportingcategory":
      return {
        identifiers: ["/reporting-categories", "/reporting-category"],
        to: "/reporting-categories",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("reporting-category"),
      };
    case "g4b_reservedcapacity":
      return {
        identifiers: ["/reserved-capacities", "/reserved-capacity"],
        to: "/reserved-capacities",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("reserved-capacity"),
      };
    case "g4b_salesplan":
      return {
        identifiers: ["/sales-plans", "/sales-plan"],
        to: "/sales-plans",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("sales-plan"),
      };
    case "g4b_seatclass":
      return {
        identifiers: ["/seat-classes", "/seat-class"],
        to: "/seat-classes",
        description:
          "This will only display if 'Enable Fixtures and Series' field is checked on the Admin Settings page",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("seat-class"),
      };
    case "g4b_series":
      return {
        identifiers: ["/series", "/serie"],
        to: "/series",
        description:
          "This will only display if 'Enable Fixtures and Series' field is checked on the Admin Settings page",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("series"),
      };
    case "g4b_taxcode":
      return {
        identifiers: ["/tax-codes", "/tax-code"],
        to: "/tax-codes",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("tax-code"),
      };
    case "g4b_terminal":
      return {
        identifiers: ["/terminals", "/terminal"],
        to: "/terminals",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("terminal"),
      };
    case "g4b_tillgroup":
      return {
        identifiers: ["/till-groups", "/till-group"],
        to: "/till-groups",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("till-group"),
      };
    case "g4b_variantpricelist":
      return {
        identifiers: ["/variant-price-lists", "/variant-price-list"],
        to: "/variant-price-lists",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("variant-price-list"),
      };
    case "g4b_varianttype":
      return {
        identifiers: ["/variant-types", "/variant-type"],
        to: "/variant-types",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("variant-type"),
      };
    case "g4b_varianttypecategory":
      return {
        identifiers: [
          "/variant-type-categories",
          "/variant-type-category",
        ],
        to: "/variant-type-categories",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("variant-type-category"),
      };
    case "g4b_venue":
      return {
        identifiers: ["/venues", "/venue"],
        to: "/venues",
        description:
          "This will only display if 'Enable Fixtures and Series' field is checked on the Admin Settings page",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("venue"),
      };
    case "g4b_voucher":
      return {
        identifiers: ["/vouchers", "/voucher"],
        to: "/vouchers",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("voucher"),
      };
    case "g4b_widgetgroup":
      return {
        identifiers: ["/question-groups", "/question-group"],
        to: "/question-groups",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("widget-group"),
      };
    case "g4b_zone":
      return {
        identifiers: ["/zones", "/zone"],
        to: "/zones",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("zone"),
      };
    case "g4c_abtest":
      return {
        identifiers: ["/abtests", "/abtest"],
        to: "/abtests",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("abtest"),
      };
    case "g4c_communication":
      return {
        identifiers: ["/communications", "/communication"],
        to: "/communications",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("communication"),
      };
    case "g4c_communicationactivity":
      return {
        identifiers: [
          "/communication-activities",
          "/communication-activity",
        ],
        to: "/communication-activities",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("communication-activity"),
      };
    case "g4c_communicationaudience":
      return {
        identifiers: [
          "/communication-audiences",
          "/communication-audience",
        ],
        to: "/communication-audiences",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("communication-audience"),
      };
    case "g4c_communicationoptions":
      return {
        to: "/communication-settings",
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("communication-settings"),
      };
    case "g4c_subscriptiongroup":
      return {
        identifiers: ["/subscription-groups", "/subscription-group"],
        to: "/subscription-groups",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("subscription-group"),
      };
    case "g4c_triggerflow":
      return {
        identifiers: ["/communication-flows", "/communication-flow"],
        to: "/communication-flows",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("communication-flow"),
      };
    case "g4d_donationbatchheader":
      return {
        identifiers: [
          "/donation-batch-headers",
          "/donation-batch-header",
        ],
        to: "/donation-batch-headers",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("donation-batch-header"),
      };
    case "g4d_fund":
      return {
        identifiers: ["/funds", "/fund"],
        to: "/funds",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("fund"),
      };
    case "g4m_membershipaccount":
      return {
        identifiers: ["/membership-accounts", "/membership-account"],
        to: "/membership-accounts",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("membership-account"),
      };
    case "journal_daily_report":
      return {
        to: "/journal-daily-reports",
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("journal-daily-reports"),
      };
    case "list":
      return {
        identifiers: ["/marketing-lists", "/marketing-list"],
        to: "/marketing-lists",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("marketing-list"),
      };
    case "page":
      return {
        to: "/page/" + page.PageId,
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        url: page.URL,
        allowedRoles: getPageAllowedRoles("page"),
      };
    case "report":
      return {
        to: "/report/" + page.PageId,
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        workspaceId: page.WorkspaceId,
        reportId: page.ReportId,
        allowedRoles: getPageAllowedRoles("report"),
      };
    case "search":
      return {
        to: "/search",
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("search"),
      };
    case "sitemap":
      return {
        to: "/sitemap",
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("sitemap"),
      };
    default:
      return {};
  }
}

function getDefaultDetailsForPage(page) {
  switch (page) {
    case "account":
      return {
        Id: "account",
        ListName: "Accounts",
        RecordName: "Account",
      };
    case "admin_settings":
      return {
        Id: "admin_settings",
        ListName: null,
        RecordName: "Admin Settings",
      };
    case "blacklist_and_mail_exclusion":
      return {
        Id: "blacklist_and_mail_exclusion",
        ListName: null,
        RecordName: "Blacklist and Mail Exclusion",
      };
    case "campaign":
      return {
        Id: "campaign",
        ListName: "Campaigns",
        RecordName: "Campaign",
      };
    case "contact":
      return {
        Id: "contact",
        ListName: "Contacts",
        RecordName: "Contact",
      };
    case "global_settings":
      return {
        Id: "global_settings",
        ListName: null,
        RecordName: "Global Settings",
      };
    case "g4_city":
      return {
        Id: "g4_city",
        ListName: "Cities",
        RecordName: "City",
      };
    case "g4_country":
      return {
        Id: "g4_country",
        ListName: "Countries",
        RecordName: "Country",
      };
    case "g4_group":
      return {
        Id: "g4_group",
        ListName: "Groups",
        RecordName: "Group",
      };
    case "g4_question":
      return {
        Id: "g4_question",
        ListName: "Questions",
        RecordName: "Question",
      };
    case "g4_region":
      return {
        Id: "g4_region",
        ListName: "Regions",
        RecordName: "Region",
      };
    case "g4a_accesscontrol":
      return {
        Id: "g4a_accesscontrol",
        ListName: "Access Control",
        RecordName: "Access Control",
      };
    case "g4b_accesscontrolprovider":
      return {
        Id: "g4b_accesscontrolprovider",
        ListName: "Access Control Providers",
        RecordName: "Access Control Provider",
      };
    case "g4b_accesspoint":
      return {
        Id: "g4b_accesspoint",
        ListName: "Access Points",
        RecordName: "Access Point",
      };
    case "g4b_additionalproduct":
      return {
        Id: "g4b_additionalproduct",
        ListName: "Additional Products",
        RecordName: "Additional Product",
      };
    case "g4b_analysiscategory":
      return {
        Id: "g4b_analysiscategory",
        ListName: "Categories",
        RecordName: "Category",
      };
    case "g4b_block":
      return {
        Id: "g4b_block",
        ListName: "Blocks",
        RecordName: "Block",
      };
    case "g4b_bookableresource":
      return {
        Id: "g4b_bookableresource",
        ListName: "Booking Resources",
        RecordName: "Booking Resource",
      };
    case "g4b_booking":
      return {
        Id: "g4b_booking",
        ListName: "Bookings",
        RecordName: "Booking",
      };
    case "g4b_bookingoperator":
      return {
        Id: "g4b_bookingoperator",
        ListName: "Operators",
        RecordName: "Operator",
      };
    case "g4b_channel":
      return {
        Id: "g4b_channel",
        ListName: "Channels",
        RecordName: "Channel",
      };
    case "g4b_channelpricelist":
      return {
        Id: "g4b_channelpricelist",
        ListName: "Channel Price Lists",
        RecordName: "Channel Price List",
      };
    case "g4b_commissioncategory":
      return {
        Id: "g4b_commissioncategory",
        ListName: "Commission Categories",
        RecordName: "Commission Category",
      };
    case "g4b_commissiongroup":
      return {
        Id: "g4b_commissiongroup",
        ListName: "Commission Groups",
        RecordName: "Commission Group",
      };
    case "g4b_commissionrate":
      return {
        Id: "g4b_commissionrate",
        ListName: "Commission Rates",
        RecordName: "Commission Rates",
      };
    case "g4b_coupon":
      return {
        Id: "g4b_coupon",
        ListName: "Coupons",
        RecordName: "Coupon",
      };
    case "g4b_coupontype":
      return {
        Id: "g4b_coupontype",
        ListName: "Coupon Types",
        RecordName: "Coupon Types",
      };
    case "g4b_fixture":
      return {
        Id: "g4b_fixture",
        ListName: "Fixtures",
        RecordName: "Fixture",
      };
    case "g4b_invoicebatchheader":
      return {
        Id: "g4b_invoicebatchheader",
        ListName: "Invoice Batch Headers",
        RecordName: "Invoice Batch Header",
      };
    case "g4b_onholdreason":
      return {
        Id: "g4b_onholdreason",
        ListName: "On Hold Reasons",
        RecordName: "On Hold Reason",
      };
    case "g4b_operatorgroup":
      return {
        Id: "g4b_operatorgroup",
        ListName: "Operator Groups",
        RecordName: "Operator Group",
      };
    case "g4b_paymentbatch":
      return {
        Id: "g4b_paymentbatch",
        ListName: "Payment Batches",
        RecordName: "Payment Batch",
      };
    case "g4b_paymentmethod":
      return {
        Id: "g4b_paymentmethod",
        ListName: "Payment Methods",
        RecordName: "Payment Method",
      };
    case "g4b_pricebreakgroup":
      return {
        Id: "g4b_pricebreakgroup",
        ListName: "Price Break Groups",
        RecordName: "Price Break Group",
      };
    case "g4b_printer":
      return {
        Id: "g4b_printer",
        ListName: "Printers",
        RecordName: "Printer",
      };
    case "g4b_printtransform":
      return {
        Id: "g4b_printtransform",
        ListName: "Print Transforms",
        RecordName: "Print Transform",
      };
    case "g4b_productbase":
      return {
        Id: "g4b_productbase",
        ListName: "Products",
        RecordName: "Product",
      };
    case "g4b_productcalendar":
      return {
        Id: "g4b_productcalendar",
        ListName: "Product Calendars",
        RecordName: "Product Calendar",
      };
    case "g4b_productgroup":
      return {
        Id: "g4b_productgroup",
        ListName: "Product Groups",
        RecordName: "Product Group",
      };
    case "g4b_promotion":
      return {
        Id: "g4b_promotion",
        ListName: "Promotions",
        RecordName: "Promotion",
      };
    case "g4b_promotionexclusiondate":
      return {
        Id: "g4b_promotionexclusiondate",
        ListName: "Promotion Exclusion Dates",
        RecordName: "Promotion Exclusion Date",
      };
    case "g4b_promotiontype":
      return {
        Id: "g4b_promotiontype",
        ListName: "Promotion Types",
        RecordName: "Promotion Type",
      };
    case "g4b_reportingcategory":
      return {
        Id: "g4b_reportingcategory",
        ListName: "Reporting Categories",
        RecordName: "Reporting Category",
      };
    case "g4b_reservedcapacity":
      return {
        Id: "g4b_reservedcapacity",
        ListName: "Reserved Capacities",
        RecordName: "Reserved Capacity",
      };
    case "g4b_salesplan":
      return {
        Id: "g4b_salesplan",
        ListName: "Sales Plans",
        RecordName: "Sales Plan",
      };
    case "g4b_seatclass":
      return {
        Id: "g4b_seatclass",
        ListName: "Seat Classes",
        RecordName: "Seat Class",
      };
    case "g4b_series":
      return {
        Id: "g4b_series",
        ListName: "Series",
        RecordName: "Serie",
      };
    case "g4b_taxcode":
      return {
        Id: "g4b_taxcode",
        ListName: "Tax Codes",
        RecordName: "Tax Code",
      };
    case "g4b_terminal":
      return {
        Id: "g4b_terminal",
        ListName: "Terminals",
        RecordName: "Terminals",
      };
    case "g4b_tillgroup":
      return {
        Id: "g4b_tillgroup",
        ListName: "Till Groups",
        RecordName: "Till Groups",
      };
    case "g4b_variantpricelist":
      return {
        Id: "g4b_variantpricelist",
        ListName: "Variant Price Lists",
        RecordName: "Variant Price Lists",
      };
    case "g4b_varianttype":
      return {
        Id: "g4b_varianttype",
        ListName: "Variant Types",
        RecordName: "Variant Type",
      };
    case "g4b_varianttypecategory":
      return {
        Id: "g4b_varianttypecategory",
        ListName: "Variant Type Categories",
        RecordName: "Variant Type Category",
      };
    case "g4b_venue":
      return {
        Id: "g4b_venue",
        ListName: "Venues",
        RecordName: "Venue",
      };
    case "g4b_voucher":
      return {
        Id: "g4b_voucher",
        ListName: "Vouchers",
        RecordName: "Voucher",
      };
    case "g4b_widgetgroup":
      return {
        Id: "g4b_widgetgroup",
        ListName: "Question Groups",
        RecordName: "Question Group",
      };
    case "g4b_zone":
      return {
        Id: "g4b_zone",
        ListName: "Zones",
        RecordName: "Zone",
      };
    case "g4c_abtest":
      return {
        Id: "g4c_abtest",
        ListName: "A/B Tests",
        RecordName: "A/B Test",
      };
    case "g4c_communication":
      return {
        Id: "g4c_communication",
        ListName: "Communications",
        RecordName: "Communication",
      };
    case "g4c_communicationactivity":
      return {
        Id: "g4c_communicationactivity",
        ListName: "Communication Activities",
        RecordName: "Communication Activity",
      };
    case "g4c_communicationaudience":
      return {
        Id: "g4c_communicationaudience",
        ListName: "Audiences",
        RecordName: "Audience",
      };
    case "g4c_communicationoptions":
      return {
        Id: "g4c_communicationoptions",
        ListName: null,
        RecordName: "Communication Settings",
      };
    case "g4c_subscriptiongroup":
      return {
        Id: "g4c_subscriptiongroup",
        ListName: "Subscription Groups",
        RecordName: "Subscription Group",
      };
    case "g4c_triggerflow":
      return {
        Id: "g4c_triggerflow",
        ListName: "Flows",
        RecordName: "Flow",
      };
    case "g4d_donationbatchheader":
      return {
        Id: "g4d_donationbatchheader",
        ListName: "Donation Batches",
        RecordName: "Donation Batch",
      };
    case "g4d_fund":
      return {
        Id: "g4d_fund",
        ListName: "Funds",
        RecordName: "Fund",
      };
    case "g4m_membershipaccount":
      return {
        Id: "g4m_membershipaccount",
        ListName: "Memberships Accounts",
        RecordName: "Memberships Account",
      };
    case "journal_daily_report":
      return {
        Id: "journal_daily_report",
        ListName: null,
        RecordName: "Journal Daily Reports",
      };
    case "list":
      return {
        Id: "list",
        ListName: "Marketing Lists",
        RecordName: "Marketing List",
      };
    case "search":
      return {
        Id: "search",
        ListName: null,
        RecordName: "Search",
      };
    case "sitemap":
      return {
        Id: "sitemap",
        ListName: null,
        RecordName: "sitemap",
      };
    default:
      return {};
  }
}

export {
  getDefaultDetailsForPage,
  getNavigationItemToAlwaysDisplayDetails,
  getNavigationItemDisplayTextValue,
  getNavigationItemDetails,
};
